import { HubDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useConfirmationAction } from '../../../hooks/confirmation-action.hook';
import { useMutationUpdateHubStatus } from '../../hubs.queries';
import {
  ConfirmationModal,
  ConfirmationNote
} from '../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function DisableHubModal({
  hub,
  projectID,
  onAbort,
  onSuccess
}: {
  hub: HubDto;
  projectID: string;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationUpdateHubStatus,
    mutationArgs: (note?: ConfirmationNote) => ({
      projectID: projectID,
      hubID: hub.id,
      enable: false,
      note: {
        content: note?.content ?? '',
        private: note?.visibility === 'private'
      }
    }),
    onSuccess,
    modalCloseDelay: 300
  });

  return (
    <ConfirmationModal
      title="Disable Hub"
      content={[
        'No one will be able to interact with this hub while disabled and it will not report its connection status.'
      ]}
      noteRequired
      noteMessage="Why are you disabling this hub?"
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Disable',
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel'
      }}
      {...state}
    />
  );
}
